/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams
 */
import * as References from './AppFatTeams';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByHub
 */
export const GET_BY_HUB_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getByHub';
export const GET_BY_HUB_QUERY: RegisteredQuery<
  'result',
  References.GetByHubRequestType,
  References.GetByHubResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_HUB_QUERY_FIELD_NAME,
  args: ['includeHierarchy', 'userFilters'],
  fetcher(
    request: References.GetByHubRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByHubResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByHubRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByHubWithHierarchy
 */
export const GET_BY_HUB_WITH_HIERARCHY_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getByHubWithHierarchy';
export const GET_BY_HUB_WITH_HIERARCHY_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetByHubWithHierarchyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_HUB_WITH_HIERARCHY_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByHubWithHierarchyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getByHubWithHierarchyRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getAccessibleByPortalUser
 */
export const GET_ACCESSIBLE_BY_PORTAL_USER_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getAccessibleByPortalUser';
export const GET_ACCESSIBLE_BY_PORTAL_USER_QUERY: RegisteredQuery<
  'result',
  References.GetAccessibleByPortalUserRequestType,
  References.GetAccessibleByPortalUserResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ACCESSIBLE_BY_PORTAL_USER_QUERY_FIELD_NAME,
  args: ['includeChildTeamMembers', 'includeHierarchy', 'userFilters'],
  fetcher(
    request: References.GetAccessibleByPortalUserRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAccessibleByPortalUserResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAccessibleByPortalUserRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getAccessibleByPortalUserUnique
 */
export const GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getAccessibleByPortalUserUnique';
export const GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAccessibleByPortalUserUniqueResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ACCESSIBLE_BY_PORTAL_USER_UNIQUE_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAccessibleByPortalUserUniqueResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAccessibleByPortalUserUniqueRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getById';
export const GET_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetByIdRequestType,
  References.GetByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['teamId', 'userFilters'],
  fetcher(
    request: References.GetByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#getByIds
 */
export const GET_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_getByIds';
export const GET_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetByIdsRequestType,
  References.GetByIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_IDS_QUERY_FIELD_NAME,
  args: ['teamIds', 'userFilters'],
  fetcher(
    request: References.GetByIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByIdsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#create
 */
export const CREATE_MUTATION_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_create';
export const CREATE_MUTATION: RegisteredQuery<
  'result',
  References.CreateRequestType,
  References.CreateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['fatTeamEgg'],
  fetcher(
    request: References.CreateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#updateFatTeams
 */
export const UPDATE_FAT_TEAMS_MUTATION_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_updateFatTeams';
export const UPDATE_FAT_TEAMS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateFatTeamsRequestType,
  References.UpdateFatTeamsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_FAT_TEAMS_MUTATION_FIELD_NAME,
  args: ['fatTeam'],
  fetcher(
    request: References.UpdateFatTeamsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateFatTeamsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateFatTeamsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#updateParentTeams
 */
export const UPDATE_PARENT_TEAMS_MUTATION_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_updateParentTeams';
export const UPDATE_PARENT_TEAMS_MUTATION: RegisteredQuery<
  'result',
  References.UpdateParentTeamsRequestType,
  References.UpdateParentTeamsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_PARENT_TEAMS_MUTATION_FIELD_NAME,
  args: ['teamIds', 'parentTeamId'],
  fetcher(
    request: References.UpdateParentTeamsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateParentTeamsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateParentTeamsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#deleteTeams
 */
export const DELETE_TEAMS_MUTATION_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_deleteTeams';
export const DELETE_TEAMS_MUTATION: RegisteredQuery<
  'result',
  References.DeleteTeamsRequestType,
  References.DeleteTeamsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_TEAMS_MUTATION_FIELD_NAME,
  args: ['teamIds'],
  fetcher(
    request: References.DeleteTeamsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteTeamsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.deleteTeamsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams#setPortalUserTeamsState
 */
export const SET_PORTAL_USER_TEAMS_STATE_MUTATION_FIELD_NAME =
  'com_hubspot_teams_rpc_AppFatTeams_setPortalUserTeamsState';
export const SET_PORTAL_USER_TEAMS_STATE_MUTATION: RegisteredQuery<
  'result',
  References.SetPortalUserTeamsStateRequestType,
  References.SetPortalUserTeamsStateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_PORTAL_USER_TEAMS_STATE_MUTATION_FIELD_NAME,
  args: ['userId', 'portalUserTeamState'],
  fetcher(
    request: References.SetPortalUserTeamsStateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetPortalUserTeamsStateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setPortalUserTeamsStateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
